export default "__VITE_ASSET__53721636__"